export class BackgroundStyleFormatHelper {
    static _targetTexts = {
        "component": "Elemento",
        "description": "Descrição",
        "tableheader": "Cabeçalho da Tabela",
        "rows": "Zebras Alternadas",
        "hourlabel": "Horas (legenda)",
        "minutelabel": "Minutos (legenda)",
        "hour": "Horas",
        "minute": "Minutos",
        "stopsbar": "Faixa da Paragem",
        "zonesbar": "Zonas",
        "durationbar": "Duração",
        "stopsline": "Linha entre Paragens",
        "smscode": "Código SMS",
        "stopcode": "Código da Paragem",
        "stopname": "Nome da Paragem",
        "linecode": "Código da Linha",
        "linename": "Nome da Linha",
        "spine": "Espinha",
        "trips": "Viagens",
        "triptime": "Tempo de Passgem",
        "header": "Cabeçalho",
        "tripsplitter": "Separador entre Viagens",
        "currentstop": "Paragem Atual",
        "hourcontinuousbackground": "Fundo Contínuo das Horas"
    }

    static getTargetTextsArray(targetsArray) {
        const output = [];
        
        for(const idx in targetsArray) {
            output.push(this._targetTexts[targetsArray[idx].toLowerCase()]);
        }

        return output;
    }

    static getTargetText(target) {
        return this._targetTexts[target.toLowerCase()];
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/helpers/BackgroundStyleFormatHelper.js